import colors from '../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        childrenContainer: {
            '& > form': {
                display: 'flex',
                flex: '1',
                height: 'auto',
            },
            background: 'transparent',
            boxShadow: 'none',
            display: 'flex',
            flex: '1',
            height: '100%',
            padding: '0px'
        },
        contentContainer: {
            borderRadius: '3px',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        },
        helpText: {
            color: 'grey',
            fontSize: '12px',
            fontStyle: 'italic'
        },
        icon: {
            '& .MuiSvgIcon-root': { fontSize: '60px' },
            height: '2em',
            paddingBottom: '16px',
            width: '3em'
        },
        logo: {
            width: '176px;',
        },
        rbccmOnline: {
            color: '#006AC3',
            fontSize: '20px',
            fontWeight: '500',
            height: '24px',
            letterSpacing: '0',
            lineHeight: '24px',
            width: '136px'
        },
        rbccmOnlineContainer: {
            display: 'flex',
            flexDirection: 'column',
            height: '33px',
            justifyContent: 'space-between',
            width: '136px',
        },
        rbccmOnlineDivider: {
            backgroundColor: '#FFC72C',
            height: '3px',
            width: '40px'
        },
        registrationContainer: {
            '@media screen and (max-width: 320px)': {
                minHeight: '40vh',
                padding: '0px'
            },
            alignItems: 'center',
            background: 'transparent',
            backgroundColor: colors[mode].primaryBackground,
            borderRadius: '8px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '55vh',
            padding: '32px',
            textAlign: 'center'
        },
        title: {
            color: colors[mode].successText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.5px',
            lineHeight: '32px',
            paddingBottom: '56px'
        },
        verbiage: {
            color: colors[mode].secondaryText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            paddingBottom: '48px',
            paddingTop: '16px',
            textAlign: 'center',
            whiteSpace: 'pre-line'
        }
    }
}
export default styles
